import { RBTechnical } from 'store/railsBuilder/reducer.types';
import { Entitlement } from 'store/user/reducer.types';

export default function getProductsNotInEntitlements(
    products: RBTechnical['products'] | undefined,
    entitlements: Entitlement[],
): RBTechnical['products'] | undefined {
    return products?.filter((product) => {
        const productInEntitlements = entitlements.find(
            ({ productId }) => product.id === productId,
        );

        // Add it to the purchasable products array if item wasn't found in the entitlements
        return productInEntitlements === undefined;
    });
}
